import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { ArrowRight, LoaderCircle } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const Waitlist = ({ selection }) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim() || loading) return;
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/waitlist`, { email, ...(selection || {}) });
      toast.success(data.message);
      setEmail("");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="waitlist" data-testid="waitlist-section" className="px-3 md:px-6 pb-6">
      <div className="bg-[#B8AFA6] rounded-3xl">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-24 md:py-36 grid grid-cols-1 md:grid-cols-12 gap-12 items-center">
          <div className="md:col-span-7">
            <Reveal>
              <p className="text-xs font-medium tracking-[0.25em] uppercase text-[#2C241E]/60 mb-4">
                07 / Waitlist
              </p>
              <h2
                data-testid="waitlist-headline"
                className="font-display text-4xl md:text-6xl tracking-tighter leading-[1.05] text-[#2C241E]"
              >
                Be the First to Know.
              </h2>
              <p
                data-testid="waitlist-subtext"
                className="mt-6 text-base md:text-lg leading-relaxed text-[#2C241E]/75 max-w-xl"
              >
                Get early access and founding-member pricing when we launch.
              </p>
            </Reveal>
          </div>
          <Reveal delay={0.15} className="md:col-span-5">
            <form data-testid="waitlist-form" onSubmit={submit} className="w-full">
              <div className="flex flex-col sm:flex-row gap-4 sm:gap-3 sm:items-end">
                <input
                  data-testid="waitlist-email-input"
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="your@email.com"
                  className="flex-1 bg-transparent border-b border-[#2C241E]/40 focus:border-[#2C241E] outline-none py-3 text-base md:text-lg text-[#2C241E] placeholder:text-[#2C241E]/40 transition-colors duration-200"
                />
                <button
                  data-testid="waitlist-submit-button"
                  type="submit"
                  disabled={loading}
                  className="inline-flex items-center justify-center gap-2 rounded-full bg-[#2C241E] text-[#EFE8DC] text-sm md:text-base font-medium px-7 py-3.5 transition-[transform,background-color,box-shadow] duration-200 hover:bg-[#3A322C] hover:scale-[1.03] hover:shadow-lg disabled:opacity-60 disabled:hover:scale-100"
                >
                  {loading ? (
                    <LoaderCircle size={18} className="animate-spin" />
                  ) : (
                    <>
                      Join the Waitlist
                      <ArrowRight size={18} strokeWidth={1.75} />
                    </>
                  )}
                </button>
              </div>
              <p className="mt-4 text-xs text-[#2C241E]/50">
                No spam. One email when we launch — that's it.
              </p>
              {selection && (
                <p data-testid="waitlist-design-selection" className="mt-2 text-xs font-medium text-[#2C241E]/70">
                  Your design: {selection.brace} · {selection.colorway} · {selection.quote}
                </p>
              )}
            </form>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
